import { Injector } from '@angular/core';
import { PageLayoutType } from 'src/app/core/enumerates/page-layout-type.enumerate';
import { PageComponent, PageComponentService } from 'src/app/core/interfaces/Builder';
import { DefaultPageComponentService } from '../services/layout/default-page-component.service';
import { HeroBannerPageComponentService } from '../services/layout/hero-banner-page-component.service';

/**
 * Factory function to create an instance of the appropriate PageComponentService based on the Page Component type.
 * This function helps in loading custom Page Component Services lazily, improving the performance.
 *
 * @param injector - The Angular Injector used to retrieve service instances.
 * @param pageComponent - The PageComponent object which contains the type information.
 * @returns An instance of PageComponentService corresponding to the type of the PageComponent.
 */
export function createPageComponentService(injector: Injector, pageComponent: PageComponent): PageComponentService {
  if (pageComponent.id === PageLayoutType.HERO_BANNER_BUILDER || pageComponent.id === PageLayoutType.HERO_BANNER_CONTENTFUL) {
    return injector.get(HeroBannerPageComponentService);
  }

  return injector.get(DefaultPageComponentService);
}
